import NewsletterSection from '../Promotional/NewsletterSection';
import Footer from './Footer';
import { useLocation } from 'react-router';
import { useMemo } from 'react';
import { JaaRoute } from '../../utilities/Links';

export default function FooterArea() {
  const location = useLocation();

  const isFrontPage = useMemo(() => {
    return location.pathname === JaaRoute.frontPage;
  }, [location]);

  return (
    <>
      {isFrontPage && <NewsletterSection />}
      <Footer />
    </>
  );
}
